import React from "react";
import { Link } from "react-router-dom";
import MarketingLayout, { Seo, Reveal, PageHero, FinalCta } from "@/components/marketing/MarketingLayout";
import { BLOG_POSTS } from "@/lib/marketingSite";
import { ArrowRight } from "@phosphor-icons/react";

const fmtDate = (d) => new Date(d + "T12:00:00Z").toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

export default function BlogPage() {
  return (
    <MarketingLayout>
      <Seo title="Blog & Resources — AI Marketing for Small Business | Vozelto" path="/blog"
        description="Practical guides on AI marketing for small business: monthly content planning, brand consistency with AI, approval-first workflows and marketing automation." />
      <PageHero caps="Blog & resources" title={<>AI marketing,<br /><span className="brand-text">explained practically.</span></>}
        subtitle="No hype. Playbooks, frameworks and honest takes on running small business marketing with an AI team." />
      <section className="max-w-6xl mx-auto px-5 pb-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="blog-grid">
          {BLOG_POSTS.map((p) => (
            <Reveal key={p.slug}>
              <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}
                className="card-matte p-6 h-full flex flex-col group transition-all duration-300 hover:-translate-y-1 hover:border-[#6B3DFF]/30 border border-transparent">
                <div className="flex items-center gap-2 text-[11px]">
                  <span className="rounded-full bg-[#6B3DFF]/12 brand-text font-semibold px-2.5 py-0.5">{p.category}</span>
                  <span className="text-[#5a5a5a]">{fmtDate(p.date)} · {p.read} read</span>
                </div>
                <h2 className="mt-3 font-head font-semibold text-lg leading-snug group-hover:text-white text-[#e6e6e6]">{p.title}</h2>
                <p className="mt-2 text-sm text-[#9a9a9a] leading-relaxed flex-1">{p.description}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold brand-text">
                  Read article <ArrowRight size={14} weight="bold" className="transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <FinalCta title="Reading About It Is Slower Than Doing It" sub="Generate your first month of marketing during the free trial." />
    </MarketingLayout>
  );
}
